import React, {Component} from 'react';
import {Button, ControlLabel, Form, FormGroup, Modal} from 'react-bootstrap';
import AssessmentSelector from './AssessmentSelector';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import GreenLeafApi from '../utils/GreenLeafApi';
import ErrorComponent from '../ErrorComponent';

class CoachAssessmentModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      assessment: null,
      errors: []
    };
  }

  async componentDidMount() {
    try {
      const res = await GreenLeafApi.Assessment.find({ assessment_id: 1 });

      this.setState({ assessment: res.data[0] });
    } catch (e) {
      this.setState({ errors: e.errors });
    }

    this.setState({ isLoading: false });
  }

  onAssessmentSelect = (assessment) => {
    this.setState({assessment});
  };

  handleRedirect = () => {
    this.props.history.push({
      pathname: `/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/assessment`,
      state: { assessment: this.state.assessment }
    });
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
        >
          <Modal.Header closeButton>
            <Modal.Title>Coach Assessment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ErrorComponent error={this.state.errors}/>
            {
              !this.state.isLoading &&
              <Form>
                <FormGroup>
                  <ControlLabel>Choose Assessment: </ControlLabel>
                  <AssessmentSelector
                    assessment={this.state.assessment}
                    onSelect={this.onAssessmentSelect}
                  />
                </FormGroup>
              </Form>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleRedirect}>Take Assessment</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

CoachAssessmentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default withRouter(CoachAssessmentModal);



// WEBPACK FOOTER //
// ./src/components/teams/CoachAssessmentModal.js